import { HttpBadStatusCodeError, UnknownError } from '@cian/peperrors/shared';

import {
  fetchGetBannerEnrichments,
  createGetBannerEnrichmentsModel,
  type TGetBannerEnrichmentsRequest,
  type TGetBannerEnrichmentsResponse,
} from '../../repositories/ad-banner/v1/get-banner-enrichments';
import { IApplicationContext } from '../../types/applicationContext';
import { IGetBannerEnrichmentsV1Response } from 'shared/repositories/ad-banner/entities/get_banner_enrichments_v1/GetBannerEnrichmentsV1Response';

export async function fetchGetNewbuildingsForSerpService(
  applicationContext: IApplicationContext,
  parameters: TGetBannerEnrichmentsRequest,
): Promise<IGetBannerEnrichmentsV1Response> {
  const { httpApi, logger } = applicationContext;

  const domain = 'src/shared/services/fetchGetNewbuildingsForSerpService.ts';

  return fetchGetBannerEnrichments({
    httpApi,
    parameters,
  }).then(
    (result: TGetBannerEnrichmentsResponse) => {
      const statusCode = result.statusCode;

      switch (result.statusCode) {
        case 200:
          return result.response;
        case 400: {
          const httpBadStatusCodeError = new HttpBadStatusCodeError({
            message: `Ошибка в запросе: ${result.response?.message}`,
            domain,
            statusCode,
            details: {
              model: JSON.stringify(createGetBannerEnrichmentsModel(parameters)),
            },
          });

          logger.warning(httpBadStatusCodeError.message, {
            domain: httpBadStatusCodeError.domain,
            details: httpBadStatusCodeError.printDetails(),
          });

          throw httpBadStatusCodeError;
        }
        default: {
          const httpBadStatusCodeError = new HttpBadStatusCodeError({
            message: `Неизвестный статус ответа: ${statusCode}`,
            domain,
            statusCode,
            details: {
              model: JSON.stringify(createGetBannerEnrichmentsModel(parameters)),
            },
          });

          logger.error(httpBadStatusCodeError.message, {
            domain: httpBadStatusCodeError.domain,
            details: httpBadStatusCodeError.printDetails(),
          });

          throw httpBadStatusCodeError;
        }
      }
    },
    error => {
      const unknownError = new UnknownError({
        message: 'Неизвестная ошибка в запросе',
        domain,
        details: {
          model: JSON.stringify(createGetBannerEnrichmentsModel(parameters)),
        },
      });

      logger.error(error, {
        domain: unknownError.domain,
        message: unknownError.message,
        details: unknownError.printDetails(),
      });

      throw unknownError;
    },
  );
}
